//Global External Imports
import { useTranslation } from "react-i18next";
import { useEffect, useState, Fragment } from "react";
import {
  Grid,
  Card,
  Box,
  Typography,
  Button,
  TextField,
  MenuItem,
  Checkbox,
  FormControlLabel,
  IconButton,
  Autocomplete,
  ListItemIcon,
  FormGroup,
} from "@mui/material";

import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import openFile from "../shared/functions/download";
import DeleteIcon from "@mui/icons-material/Delete";
import { ListItemButton } from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
//Global Internal Imports
import apiRequest from "../../functions/api";
import { useMessage } from "../../context/message-context";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import Formular from "../Formular/Formular";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import { pad } from "../../functions/default";
import { istInteger } from "../lib";
import BetragInput from "../shared/components/BetragInput";
import { FullPageSpinner } from "../lib";
import { useZulassung } from "../../context/zulassungs-context";
//Child Imports
import FormularAufbau from "./FormularAufbau";
import Gruppe from "./Gruppe";
import { useConfirm } from "../../context/confirm-context";
import VMATabelleEinstellen from "./VMATabelleEinstellen";

function FormularGenerator(props) {
  const { t } = useTranslation();
  //Standardfelder
  const { client, accessToken } = props;
  const [isLoading, setIsLoading] = useState(false);
  const { showErrorMessage, showSuccessMessage } = useMessage();
  //Felderlisten
  const [felder, setFelder] = useState({});
  const [stammfelder, setStammfelder] = useState({});
  const [listeFormular, setListeFormular] = useState([]);
  const [listeStamm, setListeStamm] = useState([]);
  const [listeGruppe, setListeGruppe] = useState([]);
  //Responsive Open KZs
  const [vmaTabelleDialog, setVmaTabelleDialog] = useState(false);
  const [openFeld, setOpenFeld] = useState("");
  const [openInfo, setOpenInfo] = useState("");
  const [openGruppe, setOpenGruppe] = useState("");
  const [openRfeld, setOpenRfeld] = useState("");
  const [openDfeld, setOpenDfeld] = useState("");
  const [openPFeld, setOpenPfeld] = useState("");
  const [openSfeld, setOpenSfeld] = useState("");
  const [openDatumsGruppe, setOpenDatumsGruppe] = useState("");
  const [openSpeichern, setOpenSpeichern] = useState(0);
  const [openLaden, setOpenLaden] = useState(0);
  const [openVorschau, setOpenVorschau] = useState(0);
  const [openMandantSelect, setOpenMandantSelect] = useState(false);
  const [openMandanFormularSelect, setOpenMandantFormularSelect] = useState(false);
  //Eingabestates1
  const [feldKey, setFeldKey] = useState("");
  const [feldBez, setFeldBez] = useState("");
  const [feldFormat, setFeldFormat] = useState(0);
  const [feldUeb, setFeldUeb] = useState(0);
  const [gruppeKey, setGruppeKey] = useState("");
  const [gruppeBez, setGruppeBez] = useState("");
  const [eingabeTyp, setEingabeTyp] = useState(0);
  const [eingabeLogik, setEingabeLogik] = useState(0);
  const [eingabeNegativ, setEingabeNegativ] = useState(false);
  const [logikLoa, setLogikLoa] = useState("");
  const [logikPflBedingung, setLogikPflBedingung] = useState("");
  const [logikArt, setLogikArt] = useState(0);
  const [logikWert, setLogikWert] = useState("");
  const [eingabeInhalt, setEingabeInhalt] = useState("");
  const [eingabeExtra, setEingabeExtra] = useState("");
  const [eingabeVon, setEingabeVon] = useState(0);
  const [eingabeBis, setEingabeBis] = useState(0);
  const [eingabeLimit, setEingabeLimit] = useState(0);
  const [eingabeLabel, setEingabeLabel] = useState("");
  const [eingabePflicht, setEingabePflicht] = useState(false);
  const [eingabeFibuName, setEingabeFibuName] = useState("");

  const [infoTyp, setInfoTyp] = useState(0);
  const [infoInhalt, setInfoInhalt] = useState("");
  const [infoSysinfo, setInfoSysinfo] = useState(0);
  const [rfeldInhalt, setRfeldInhalt] = useState("");
  const [pfeldInhalt, setPfeldInhalt] = useState([]);
  const [pfeldExtra, setPfeldExtra] = useState("");

  const [rfeldTyp, setRfeldTyp] = useState(0);
  const [rfeldExtra, setRfeldExtra] = useState("");
  const [rfeldNegativ, setRfeldNegativ] = useState(false);
  const [multi, setMulti] = useState(0);
  const [gruppeLoop, setGruppeLoop] = useState(0);
  const [formKey, setFormKey] = useState("F000");
  const [formBez, setFormBez] = useState("");
  const [formArt, setFormArt] = useState(0);
  const [ladenFormular, setLadenFormular] = useState(0);
  const [hdok, setHdok] = useState(false);
  //Sonbstige Konstanten
  const [maxEingabe, setMaxEingabe] = useState({});
  const [maxInfo, setMaxInfo] = useState({});
  const [maxGruppe, setMaxGruppe] = useState({});
  const [maxDatumsGruppe, setMaxDatumsGruppe] = useState({});
  const [maxRfeld, setMaxRfeld] = useState({});
  const [maxDfeld, setMaxDfeld] = useState({});
  const [maxPfeld, setMaxPfeld] = useState({});
  const [maxForm, setMaxForm] = useState(0);
  const [maxFormG, setMaxFormG] = useState(0);
  const [feldtyp, setFeldtyp] = useState([]);
  const [feldlogik, setFeldlogik] = useState([]);
  const [sysinfo, setSysinfo] = useState([]);
  const [dfeldDb, setDfeldDb] = useState(0);
  const [dfeldFeld, setDfeldFeld] = useState(0);
  const [dbliste, setDbliste] = useState([]);
  const [logikarten, setLogikarten] = useState([]);
  const [fibuZusatzfelder, setFibuZusatzfelder] = useState([]);
  const [logikloas, setLogikloas] = useState([]);
  const [infotyp, setInfotyp] = useState([]);
  const [rfeldtyp, setRfeldtyp] = useState([]);
  const [pfeldtyp, setPfeldtyp] = useState([]);
  const [multiauswahl, setMultiauswahl] = useState(0);
  const [format, setFormat] = useState([]);
  const [formulare, setFormulare] = useState([]);
  const [formular, setFormular] = useState("F000");
  const [formularBez, setFormularBez] = useState("");
  const [uebergaben, setUebergaben] = useState({});
  const [files, setFiles] = useState([]);
  const [dokfiles, setDokfiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hper, setHper] = useState({});
  const [global, setGlobal] = useState("");
  const { zulassung } = useZulassung();
  const [mandantenFormulare, setMandantenFormulare] = useState([]);
  const [listMandant, setListMandant] = useState([]);
  const [listFormular, setListFormular] = useState([]);
  const [clientServer, setClientServer] = useState("");
  //const [hperFelder,setHperFelder]=useState([])
  const [vmaStandardTabelle, setVmaStandardTabelle] = useState([]);
  const [felderError, setFelderError] = useState([]);
  const confirm = useConfirm();

  //PVX Kommunikation
  useEffect(() => {
    init();
    localStorage.setItem("formular", "");
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (infoTyp === 7 && openInfo != "") {
      setFeldBez("Zeilenumbruch");
    }
  }, [infoTyp]);

  const init = () => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "FORGEN",
      statement: "UEBERSICHT",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, (r) => postLaden(r));
  };
  function SaveLocal(type, value) {
    if (type === "felder") {
      setFelder(value);
      localStorage.setItem("felder", JSON.stringify(value));
    }
    if (type === "formular") {
      setFormular(value);
      localStorage.setItem("formular", JSON.stringify(value));
    }
    if (type === "listeFormular") {
      setListeFormular(value);
      localStorage.setItem("listeFormular", JSON.stringify(value));
    }
    if (type === "listeStamm") {
      setListeStamm(value);
      localStorage.setItem("listeStamm", JSON.stringify(value));
    }
    if (type === "listeGruppe") {
      setListeGruppe(value);
      localStorage.setItem("listeGruppe", JSON.stringify(value));
    }
    if (type === "maxEingabe") {
      setMaxEingabe(value);
      localStorage.setItem("maxEingabe", JSON.stringify(value));
    }
    if (type === "maxInfo") {
      setMaxInfo(value);
      localStorage.setItem("maxInfo", JSON.stringify(value));
    }
    if (type === "maxGruppe") {
      setMaxGruppe(value);
      localStorage.setItem("maxGruppe", JSON.stringify(value));
    }
    if (type === "maxDatumsGruppe") {
      setMaxDatumsGruppe(value);
      localStorage.setItem("maxDatumsGruppe", JSON.stringify(value));
    }

    if (type === "maxRfeld") {
      setMaxRfeld(value);
      localStorage.setItem("maxRfeld", JSON.stringify(value));
    }
    if (type === "maxDfeld") {
      setMaxDfeld(value);
      localStorage.setItem("maxDfeld", JSON.stringify(value));
    }
    if (type === "maxPfeld") {
      setMaxPfeld(value);
      localStorage.setItem("maxPfeld", JSON.stringify(value));
    }

    if (type === "maxForm") {
      setMaxForm(value);
      localStorage.setItem("maxForm", JSON.stringify(value));
    }
    if (type === "maxFormG") {
      setMaxFormG(value);
      localStorage.setItem("maxFormG", JSON.stringify(value));
    }
  }
  function Von(val, typ) {
    if (typ === "10") {
      if (istInteger(val) === false) return;
    }
    setEingabeVon(val);
  }
  function Bis(val, typ) {
    if (typ === "10") {
      if (istInteger(val) === false) return;
    }
    setEingabeBis(val);
  }
  function LoadLocal() {
    setFelder(JSON.parse(localStorage.getItem("felder")));
    setFormular(JSON.parse(localStorage.getItem("formular")));
    setListeFormular(JSON.parse(localStorage.getItem("listeFormular")));
    setListeStamm(JSON.parse(localStorage.getItem("listeStamm")));
    setListeGruppe(JSON.parse(localStorage.getItem("listeGruppe")));
    setMaxEingabe(JSON.parse(localStorage.getItem("maxEingabe")));
    setMaxInfo(JSON.parse(localStorage.getItem("maxInfo")));
    setMaxGruppe(JSON.parse(localStorage.getItem("maxGruppe")));
    setMaxDatumsGruppe(JSON.parse(localStorage.getItem("maxDatumsGruppe")));
    setMaxRfeld(JSON.parse(localStorage.getItem("maxRfeld")));
    setMaxDfeld(JSON.parse(localStorage.getItem("maxDfeld")));
    setMaxPfeld(JSON.parse(localStorage.getItem("maxPfeld")));
    setMaxForm(JSON.parse(localStorage.getItem("maxForm")));
    setMaxFormG(JSON.parse(localStorage.getItem("maxFormG")));
  }
  function postLaden(response, bonus, bonusformular) {
    setIsLoading(false);
    if (response.status === 200) {
      setVmaStandardTabelle(response.data.aufwendungen);
      setFelder(response.data.felder);
      setStammfelder(response.data.stammfelder);
      setHper(response.data.hper);
      setGlobal(response.data.global);
      //if (response.data.hperFelder) setHperFelder(response.data.hperFelder);
      if (response.data.listeFormular) setListeFormular(response.data.listeFormular);
      if (response.data.listeStamm) setListeStamm(response.data.listeStamm);
      if (response.data.formulare) {
        setFormulare(response.data.formulare);
      } else {
        setFormulare([]);
      }
      if (response.data.feldtyp) setFeldtyp(response.data.feldtyp);
      if (response.data.feldlogik) setFeldlogik(response.data.feldlogik);
      if (response.data.sysinfo) setSysinfo(response.data.sysinfo || []);
      if (response.data.dbliste) setDbliste(response.data.dbliste);
      if (response.data.fibuZusatzfelder) setFibuZusatzfelder(response.data.fibuZusatzfelder);
      if (response.data.logikarten) setLogikarten(response.data.logikarten);
      if (response.data.logikloas) setLogikloas(response.data.logikloas);
      if (response.data.infotyp) setInfotyp(response.data.infotyp);
      if (response.data.rfeldtyp) setRfeldtyp(response.data.rfeldtyp);
      if (response.data.pfeld) setPfeldtyp(response.data.pfeld);
      if (response.data.CLIENT_SERVER) setClientServer(response.data.CLIENT_SERVER);
      if (response.data.multiauswahl) setMultiauswahl(response.data.multiauswahl);
      if (response.data.format) setFormat(response.data.format);
      if (response.data.uebergaben) {
        setUebergaben(response.data.uebergaben);
      } else {
        setUebergaben({});
      }
      setMaxEingabe(response.data.maxEingabe);
      setMaxInfo(response.data.maxInfo);
      setMaxGruppe(response.data.maxGruppe);
      setMaxDatumsGruppe(response.data.maxDatumsGruppe);
      setMaxRfeld(response.data.maxRfeld);
      setMaxDfeld(response.data.maxDfeld);
      setMaxPfeld(response.data.maxPfeld);
      setMaxForm(Number(response.data.maxForm));
      setMaxFormG(Number(response.data.maxFormG));
      if (bonus) {
        var tmpformular = ladenFormular;
        if (bonusformular && response.data.formulare.findIndex((i) => i.key === bonusformular) >= 0) {
          tmpformular = response.data.formulare.findIndex((i) => i.key === bonusformular);
        }
        if (!response.data.felder[response.data.formulare[tmpformular].key]) return;

        var inhalt = response.data.felder[response.data.formulare[tmpformular].key]["F" + response.data.formulare[tmpformular].key.substr(1)].inhalt.split(";");
        var i;
        var tmpliste = [];
        for (i = 0; i < inhalt.length; i++) {
          if (inhalt[i] === "") continue;
          if (!response.data.felder[response.data.formulare[tmpformular].key][inhalt[i]] && !response.data.stammfelder[inhalt[i]]) continue;
          tmpliste.push(inhalt[i]);
        }
        SaveLocal("listeFormular", tmpliste);
        SaveLocal("formular", response.data.formulare[tmpformular].key);
        setFormularBez(response.data.formulare[tmpformular].name);
        Reset();
        setFormKey(response.data.formulare[tmpformular].key);
        setFormBez(response.data.formulare[tmpformular].name);
        if (response.data.formulare[tmpformular].kz) {
          setFormArt(Number(response.data.formulare[tmpformular].kz));
        }
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  function Speichern(object, aktion) {
    setIsLoading(true);
    if (formulare.findIndex((i) => i.key === formular) >= 0) setLadenFormular(formulare.findIndex((i) => i.key === formular));
    const payload = {
      mandant: client,
      program: "FORGEN",
      statement: "FORMULAR_SPEICHERN",
      object: object,
      aktion: aktion,
      felder: felder,
      formular: formular,
    };
    const data = new FormData();
    for (let index = 0; index < dokfiles.length; index++) {
      data.append("file", dokfiles[index]);
    }
    data.append("payload", JSON.stringify(payload));
    const headers = {
      Authorization: "Bearer " + accessToken,
      Mandant: client,
      Program: "FORGEN",
      Statement: "FORMULAR_SPEICHERN",
    };
    apiRequest("POST", "upload", data, headers, (r) => postLaden(r, true, object.key));
  }
  function DateiLaden(key, art) {
    setLoading(true);
    const payload = {
      mandant: client,
      program: "FORGEN",
      statement: "DATEI_LADEN",
      key: key,
      art: art,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        var fileName = "Datei" + ".pdf";
        var contentFile = response.data;
        openFile(fileName, contentFile);
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  }
  //Standardfunktionen
  if (isLoading) {
    return <LoadingComponent path={props.location} />;
  }
  //Arbeitsfunktionen
  function ChangeFelder(id, value, newfelder) {
    //felder[formular][id].antwort=value
    setFelder(JSON.parse(JSON.stringify(newfelder)));
  }
  function ChangeFiles(newFile) {
    var tmpliste = files;
    tmpliste.push(newFile);
    setFiles(tmpliste);
  }
  function LoadPdf() {
    setIsLoading(true);

    const payload = {
      mandant: client,
      program: "FORGEN",
      statement: "PDF",
      key: formular,
      felder: felder,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        var fileName = "Formular.pdf";
        var contentFile = response.data;
        openFile(fileName, contentFile);
        setIsLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setIsLoading(false);
        showErrorMessage("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut.");
      });
  }

  function LoeschenFormular() {
    if (formular === "F000") return;
    var tmpindex = formulare.findIndex((item) => item.key === formular);
    if (tmpindex < 0) return;
    const newFormular = {
      key: formular,
      art: formular.substr(0, 1),
    };
    Reset();
    Speichern(newFormular, "delete");
    NeuFormular();
  }
  function FeldBearbeiten(feld) {
    if (feld.art === "E") {
      setFeldKey(feld.key);
      setFeldBez(feld.name);
      setEingabeInhalt(feld.inhalt);
      setEingabeExtra(feld.extra);
      setEingabeVon(feld.von);
      setEingabeBis(feld.bis);
      setEingabeLimit(feld.limit);
      setEingabeLabel(feld.label === "1" ? true : false);
      setEingabeNegativ(feld.negativ === "1" ? true : false);
      setLogikLoa(logikloas.findIndex((e) => e.key === feld.logikloa));
      setLogikWert(feld.logikwert);
      setLogikArt(logikarten.findIndex((e) => e.key === feld.logikart));
      setEingabeLogik(feldlogik.findIndex((e) => e.key === feld.logik));
      setEingabeTyp(feldtyp.findIndex((e) => e.key === feld.typ));
      setFeldFormat(format.findIndex((e) => e.key === feld.format));
      setEingabeFibuName(feld.eingabeFibuName);
      setEingabePflicht(feld.pflicht === "1" ? true : false);
      setFeldUeb(feld.uebergabe);
      setMulti(multiauswahl.findIndex((e) => e.key === feld.multi));
      setOpenFeld("loaded");
    }
    if (feld.art === "G") {
      setGruppeKey(feld.key);
      setGruppeBez(feld.name);
      setGruppeLoop(feld.logik);

      SaveLocal("listeGruppe", feld.inhalt.split(";"));
      setOpenGruppe("loaded");
    }
    if (feld.art === "I") {
      setFeldKey(feld.key);
      setFeldBez(feld.name);
      setInfoInhalt(feld.inhalt);
      setInfoTyp(infotyp.findIndex((e) => e.key === feld.typ));
      setInfoSysinfo(sysinfo.findIndex((e) => e.key === feld.extra));
      setFeldFormat(format.findIndex((e) => e.key === feld.format));
      setOpenInfo("loaded");
    }
    if (feld.art === "R") {
      setFeldKey(feld.key);
      setFeldBez(feld.name);
      setRfeldTyp(rfeldtyp.findIndex((e) => e.key === feld.typ));
      setLogikLoa(logikloas.findIndex((e) => e.key === feld.logikloa));
      setLogikWert(feld.logikwert);
      setLogikArt(logikarten.findIndex((e) => e.key === feld.logikart));
      setEingabeLogik(feldlogik.findIndex((e) => e.key === feld.logik));
      setRfeldInhalt(feld.inhalt);
      setRfeldExtra(feld.extra);
      setRfeldNegativ(feld.negativ === "1" ? true : false);
      setFeldUeb(feld.uebergabe);
      /*setFeldFormat(format.findIndex((e)=>e.key===feld.format))*/
      setOpenRfeld("loaded");
    }
    if (feld.art === "P") {
      setFeldKey(feld.key);
      setFeldBez(feld.name);
      setPfeldExtra(feld.extra);
      setPfeldInhalt(feld.inhalt);
      setOpenPfeld("loaded");
    }
    if (feld.art === "V") {
      setGruppeKey(feld.key);
      setGruppeBez(feld.name);
      setGruppeLoop(feld.logik);

      SaveLocal("listeGruppe", feld.inhalt.split(";"));
      setOpenDatumsGruppe("loaded");
    }
    if (feld.art === "D") {
      setFeldKey(feld.key);
      setFeldBez(feld.name);
      setDfeldDb(dbliste.findIndex((e) => e.key === feld.inhalt));
      setDfeldFeld(dbliste[dfeldDb].felder.findIndex((e) => e.key === feld.extra));
      setFeldUeb(feld.uebergabe);
      setFeldFormat(format.findIndex((e) => e.key === feld.format));
      setOpenDfeld("loaded");
    }
    if (feld.art === "S") {
      setFeldKey(feld.key);
      setFeldBez(feld.name);
      setFeldUeb(feld.uebergabe);
      setOpenSfeld("loaded");
    }
  }
  function NeuFormular() {
    SaveLocal("formular", "F000");
    setFormularBez("");
    setFormKey("F000");
    setFormBez("");
    setFormArt(0);
    SaveLocal("listeFormular", []);
  }
  function LadenFormular() {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "FORGEN",
      statement: "UEBERSICHT",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, (r) => postLaden(r, true));
  }
  function SpeichernFormular() {
    var tmpkey = formKey;
    var tmpart = "F";
    if (formArt === 1 || formKey.substr(0, 1) === "G") {
      if (tmpkey === "F000") tmpkey = "G" + pad(maxFormG, 3).toString();
      tmpart = "G";
    } else {
      if (tmpkey === "F000") tmpkey = "F" + pad(maxForm, 3).toString();
      tmpart = "F";
    }

    const newFormular = {
      key: tmpkey,
      art: tmpart,
      name: formBez,
      hdok: hdok ? "1" : "0",
      inhalt: listeFormular.join(";"),
    };
    Speichern(newFormular, "save");
    SaveLocal("formular", tmpkey);
    setFormularBez(formBez);
    Reset();
  }
  function LoeschenFeld(liste, setListe) {
    console.log(openGruppe);
    const newFelder = {
      ...felder,
    };

    delete newFelder[formular][feldKey];
    console.log(liste);
    var tmpindex = liste.indexOf(feldKey);
    if (tmpindex >= 0) {
      var tmpliste = [...liste];
      tmpliste.splice(tmpindex, 1);
      SaveLocal(setListe, tmpliste);
    }
    SaveLocal("felder", newFelder);
    Reset();
  }
  function DelFeld(feld, index) {
    const newFelder = {
      ...felder,
    };
    if (feld && newFelder[formular] && newFelder[formular][feld.key]) {
      delete newFelder[formular][feld.key];
    }
    var tmpliste = [...listeFormular];
    tmpliste.splice(index, 1);
    SaveLocal("listeFormular", tmpliste);
    SaveLocal("felder", newFelder);
    Reset();
  }
  function SpeichernEingabe(liste, setListe) {
    if (feldBez === "") {
      showErrorMessage(t("Bitte geben Sie eine Feldbezeichnung ein"));
      return;
    }

    const newFeld = {
      key: feldKey,
      art: "E",
      name: feldBez,
      typ: feldtyp[eingabeTyp].key,
      logik: feldlogik[eingabeLogik] ? feldlogik[eingabeLogik].key : "",
      logikart: logikarten[logikArt] ? logikarten[logikArt].key : "",
      logikloa: logikloas[logikLoa] ? logikloas[logikLoa].key : "",
      logikwert: logikWert,
      logikPflBedingung: logikPflBedingung,
      format: format[feldFormat].key,
      inhalt: eingabeInhalt,
      extra: eingabeExtra,
      von: eingabeVon,
      bis: eingabeBis,
      limit: eingabeLimit,
      label: eingabeLabel ? "1" : "0",
      negativ: eingabeNegativ ? "1" : "0",
      pflicht: eingabePflicht ? "1" : "0",
      eingabeFibuName: eingabeFibuName,
      uebergabe: feldUeb,
      multi: multiauswahl && multiauswahl[multi] ? multiauswahl[multi].key : "",
    };
    const newFelder = {
      ...felder,
      [formular]: {
        ...felder[formular],
        [feldKey]: newFeld,
      },
    };
    if (liste.some((item) => item === feldKey) === false) {
      var tmparray = [...liste];
      tmparray.push(feldKey);
      SaveLocal(setListe, tmparray);
      var tmpmax = maxEingabe;
      tmpmax[formular] = pad(Number(maxEingabe[formular]) + 1, 3).toString();
      SaveLocal("maxEingabe", tmpmax);
    }
    SaveLocal("felder", newFelder);
    Reset();
  }
  function SpeichernInfo(liste, setListe) {
    if (feldBez === "") {
      showErrorMessage(t("Bitte geben Sie eine Feldbezeichnung ein"));
      return;
    }
    const newInfo = {
      key: feldKey,
      art: "I",
      name: feldBez,
      typ: infotyp[infoTyp].key,
      format: format[feldFormat].key,
      extra: sysinfo[infoSysinfo] ? sysinfo[infoSysinfo].key : "",
      inhalt: infoInhalt,
    };
    const newFelder = {
      ...felder,
      [formular]: {
        ...felder[formular],
        [feldKey]: newInfo,
      },
    };
    if (liste.some((item) => item === feldKey) === false) {
      var tmparray = [...liste];
      tmparray.push(feldKey);
      SaveLocal(setListe, tmparray);
      var tmpmax = maxInfo;
      tmpmax[formular] = pad(Number(maxInfo[formular]) + 1, 3).toString();
      SaveLocal("maxInfo", tmpmax);
    }
    SaveLocal("felder", newFelder);
    Reset();
  }
  function SpeichernInfo(liste, setListe) {
    if (feldBez === "") {
      showErrorMessage(t("Bitte geben Sie eine Feldbezeichnung ein"));
      return;
    }
    const newInfo = {
      key: feldKey,
      art: "I",
      name: feldBez,
      typ: infotyp[infoTyp].key,
      format: format[feldFormat].key,
      extra: sysinfo[infoSysinfo] ? sysinfo[infoSysinfo].key : "",
      inhalt: infoInhalt,
    };
    const newFelder = {
      ...felder,
      [formular]: {
        ...felder[formular],
        [feldKey]: newInfo,
      },
    };
    if (liste.some((item) => item === feldKey) === false) {
      var tmparray = [...liste];
      tmparray.push(feldKey);
      SaveLocal(setListe, tmparray);
      var tmpmax = maxInfo;
      tmpmax[formular] = pad(Number(maxInfo[formular]) + 1, 3).toString();
      SaveLocal("maxInfo", tmpmax);
    }
    SaveLocal("felder", newFelder);
    Reset();
  }
  function SpeichernGruppe() {
    if (gruppeBez === "") {
      showErrorMessage(t("Bitte geben Sie eine Feldbezeichnung ein"));
      return;
    }
    if (!listeGruppe || listeGruppe.length === 0) {
      showErrorMessage(t("Bitte legen Sie mindestens 1 Feld für die Gruppe an"));
      return;
    }
    const newGruppe = {
      key: gruppeKey,
      art: "G",
      name: gruppeBez,
      logik: gruppeLoop,
      inhalt: listeGruppe.join(";"),
    };
    const newFelder = {
      ...felder,
      [formular]: {
        ...felder[formular],
        [gruppeKey]: newGruppe,
      },
    };
    if (listeFormular.some((item) => item === gruppeKey) === false) {
      var tmparray = [...listeFormular];
      tmparray.push(gruppeKey);
      SaveLocal("listeFormular", tmparray);
      var tmpmax = maxGruppe;
      tmpmax[formular] = pad(Number(maxGruppe[formular]) + 1, 3).toString();
      SaveLocal("maxGruppe", tmpmax);
    }
    SaveLocal("felder", newFelder);
    Reset();
    ResetGruppe();
  }

  function SpeichernDatumsgruppe() {
    if (gruppeBez === "") {
      showErrorMessage(t("Bitte geben Sie eine Feldbezeichnung ein"));
      return;
    }
    if (!listeGruppe || listeGruppe.length === 0) {
      showErrorMessage(t("Bitte legen Sie mindestens 1 Feld für die Gruppe an"));
      return;
    }

    const newGruppe = {
      key: gruppeKey,
      art: "V",
      name: gruppeBez,
      logik: gruppeLoop,
      inhalt: listeGruppe.join(";"),
    };
    const newFelder = {
      ...felder,
      [formular]: {
        ...felder[formular],
        [gruppeKey]: newGruppe,
      },
    };
    if (listeFormular.some((item) => item === gruppeKey) === false) {
      var tmparray = [...listeFormular];
      tmparray.push(gruppeKey);
      SaveLocal("listeFormular", tmparray);
      var tmpmax = maxGruppe;
      tmpmax[formular] = pad(Number(maxGruppe[formular]) + 1, 3).toString();
      SaveLocal("maxDatumsGruppe", tmpmax);
    }
    SaveLocal("felder", newFelder);
    Reset();
    ResetGruppe();
  }
  function SpeichernRfeld(liste, setListe) {
    if (feldBez === "") {
      showErrorMessage(t("Bitte geben Sie eine Feldbezeichnung ein"));
      return;
    }
    const newRfeld = {
      key: feldKey,
      art: "R",
      name: feldBez,
      typ: rfeldtyp[rfeldTyp].key,
      logik: feldlogik[eingabeLogik] ? feldlogik[eingabeLogik].key : "",
      logikart: logikarten[logikArt] ? logikarten[logikArt].key : "",
      logikloa: logikloas[logikLoa] ? logikloas[logikLoa].key : "",
      logikwert: logikWert,
      inhalt: rfeldInhalt,
      extra: rfeldExtra,
      negativ: rfeldNegativ ? "1" : "0",
      uebergabe: feldUeb,
      /*format:format[feldFormat].key,
       */
    };
    const newFelder = {
      ...felder,
      [formular]: {
        ...felder[formular],
        [feldKey]: newRfeld,
      },
    };
    if (liste.some((item) => item === feldKey) === false) {
      var tmparray = [...liste];
      tmparray.push(feldKey);
      SaveLocal(setListe, tmparray);
      var tmpmax = maxRfeld;
      tmpmax[formular] = pad(Number(maxRfeld[formular]) + 1, 3).toString();
      SaveLocal("maxRfeld", tmpmax);
    }
    SaveLocal("felder", newFelder);
    Reset();
  }
  function SpeichernDfeld(liste, setListe) {
    if (feldBez === "") {
      showErrorMessage(t("Bitte geben Sie eine Feldbezeichnung ein"));
      return;
    }
    const newDfeld = {
      key: feldKey,
      art: "D",
      name: feldBez,
      inhalt: dbliste[dfeldDb] ? dbliste[dfeldDb].key : "",
      extra: dbliste[dfeldDb].felder[dfeldFeld] ? dbliste[dfeldDb].felder[dfeldFeld].key : "",
      format: format[feldFormat].key,
      uebergabe: feldUeb,
    };
    const newFelder = {
      ...felder,
      [formular]: {
        ...felder[formular],
        [feldKey]: newDfeld,
      },
    };
    if (liste.some((item) => item === feldKey) === false) {
      var tmparray = [...liste];
      tmparray.push(feldKey);
      SaveLocal(setListe, tmparray);
      var tmpmax = maxDfeld;
      tmpmax[formular] = pad(Number(maxDfeld[formular]) + 1, 3).toString();
      SaveLocal("maxDfeld", tmpmax);
    }
    SaveLocal("felder", newFelder);
    Reset();
  }
  function SpeichernPFeld(liste, setListe) {
    if (feldBez === "") {
      showErrorMessage(t("Bitte geben Sie eine Feldbezeichnung ein"));
      return;
    }

    const newPfeld = {
      key: feldKey,
      art: "P",
      name: feldBez,
      inhalt: pfeldInhalt,
      extra: pfeldExtra,
      inhaltKeys: pfeldtyp
        ?.find((e) => e.key === pfeldExtra)
        ?.settings?.map((e) => e.key)
        .join(";"),
    };
    const newFelder = {
      ...felder,
      [formular]: {
        ...felder[formular],
        [feldKey]: newPfeld,
      },
    };
    if (liste.some((item) => item === feldKey) === false) {
      var tmparray = [...liste];
      tmparray.push(feldKey);
      SaveLocal(setListe, tmparray);
      var tmpmax = maxDfeld;
      tmpmax[formular] = pad(Number(maxDfeld[formular]) + 1, 3).toString();
      SaveLocal("maxPfeld", tmpmax);
    }
    SaveLocal("felder", newFelder);
    Reset();
  }

  function SpeichernSfeld(liste, setListe) {
    const newFeld = {
      key: feldKey,
      art: "S",
      name: feldBez,
      uebergabe: feldUeb,
    };
    const newFelder = {
      ...felder,
      [formular]: {
        ...felder[formular],
        [feldKey]: newFeld,
      },
    };
    if (liste.some((item) => item === feldKey) === false) {
      var tmparray = [...liste];
      tmparray.push(feldKey);
      SaveLocal(setListe, tmparray);
      var tmpmax = maxEingabe;
      tmpmax[formular] = pad(Number(maxEingabe[formular]) + 1, 3).toString();
      SaveLocal("maxEingabe", tmpmax);
    }
    SaveLocal("felder", newFelder);
    Reset();
  }
  function NewSfeld(skey, sname) {
    const newFeld = {
      key: skey,
      art: "S",
      name: sname,
      uebergabe: "",
    };
    const newFelder = {
      ...felder,
      [formular]: {
        ...felder[formular],
        [skey]: newFeld,
      },
    };
    SaveLocal("felder", newFelder);
  }
  function CopyFeld(feld, index) {
    var newInhalt = "";
    var tmpkey = "";
    var tmpmax = "";
    if (feld.art === "E") {
      tmpkey = "E" + pad(maxEingabe[formular], 3).toString();
      tmpmax = maxEingabe;
      tmpmax[formular] = pad(Number(maxEingabe[formular]) + 1, 3).toString();
      SaveLocal("maxEingabe", tmpmax);
    }
    if (feld.art === "I") {
      tmpkey = "I" + pad(maxInfo[formular], 3).toString();
      tmpmax = maxInfo;
      tmpmax[formular] = pad(Number(maxInfo[formular]) + 1, 3).toString();
      SaveLocal("maxInfo", tmpmax);
    }
    if (feld.art === "R") {
      tmpkey = "R" + pad(maxRfeld[formular], 3).toString();
      tmpmax = maxRfeld;
      tmpmax[formular] = pad(Number(maxRfeld[formular]) + 1, 3).toString();
      SaveLocal("maxRfeld", tmpmax);
    }
    if (feld.art === "D") {
      tmpkey = "D" + pad(maxDfeld[formular], 3).toString();
      tmpmax = maxDfeld;
      tmpmax[formular] = pad(Number(maxDfeld[formular]) + 1, 3).toString();
      SaveLocal("maxDfeld", tmpmax);
    }
    if (feld.art === "G") {
      tmpkey = "G" + pad(maxGruppe[formular], 3).toString();
      tmpmax = maxGruppe;
      tmpmax[formular] = pad(Number(maxGruppe[formular]) + 1, 3).toString();
      SaveLocal("maxGruppe", tmpmax);
      var newFelderGrp = { ...felder };
      var newFeldGrp = {};
      var tmpFeld = {};
      var tmpmaxe = maxEingabe;
      var tmpmaxi = maxInfo;
      var tmpmaxr = maxRfeld;
      var tmpmaxd = maxDfeld;
      var tmpkeyGrp = "";
      felder[formular][feld.key].inhalt.split(";").forEach((item) => {
        tmpFeld = felder[formular][item];

        if (tmpFeld.art === "E") {
          tmpkeyGrp = "E" + pad(tmpmaxe[formular], 3).toString();
          tmpmaxe[formular] = pad(Number(tmpmaxe[formular]) + 1, 3).toString();
        }
        if (tmpFeld.art === "I") {
          tmpkeyGrp = "I" + pad(tmpmaxi[formular], 3).toString();
          tmpmaxi[formular] = pad(Number(tmpmaxi[formular]) + 1, 3).toString();
        }
        if (tmpFeld.art === "R") {
          tmpkeyGrp = "R" + pad(tmpmaxr[formular], 3).toString();
          tmpmaxr[formular] = pad(Number(tmpmaxr[formular]) + 1, 3).toString();
        }
        if (tmpFeld.art === "D") {
          tmpkeyGrp = "D" + pad(tmpmaxd[formular], 3).toString();
          tmpmaxd[formular] = pad(Number(tmpmaxd[formular]) + 1, 3).toString();
        }

        newFeldGrp = {
          ...tmpFeld,
          key: tmpkeyGrp,
        };
        newFelderGrp = {
          ...newFelderGrp,
          [formular]: {
            ...newFelderGrp[formular],
            [tmpkeyGrp]: newFeldGrp,
          },
        };

        newInhalt += tmpkeyGrp + ";";
      });
      SaveLocal("maxEingabe", tmpmaxe);
      SaveLocal("maxInfo", tmpmaxi);
      SaveLocal("maxRfeld", tmpmaxr);
      SaveLocal("maxDfeld", tmpmaxd);
      if (newInhalt.length > 0) newInhalt = newInhalt.substring(0, newInhalt.length - 1);
    }

    if (feld.art === "S") {
      return;
    }
    var newFeld = {};
    var newFelder = {};
    if (feld.art === "G") {
      newFeld = {
        ...feld,
        key: tmpkey,
        inhalt: newInhalt,
      };
      newFelder = {
        ...newFelderGrp,
        [formular]: {
          ...newFelderGrp[formular],
          [tmpkey]: newFeld,
        },
      };
    } else {
      newFeld = {
        ...feld,
        key: tmpkey,
      };
      newFelder = {
        ...felder,
        [formular]: {
          ...felder[formular],
          [tmpkey]: newFeld,
        },
      };
    }
    if (openGruppe) {
      const newArray = Array.from(listeGruppe);
      newArray.splice(index + 1, 0, tmpkey);
      SaveLocal("listeGruppe", newArray);
    } else {
      const newArray = Array.from(listeFormular);
      newArray.splice(index + 1, 0, tmpkey);
      SaveLocal("listeFormular", newArray);
    }

    SaveLocal("felder", newFelder);
  }
  const getRechenFeldOptions = () => {
    const spesenModus = rfeldTyp === 3;

    const options = [];
    felder[formular] !== undefined
      ? Object.keys(felder[formular]).forEach((key) => {
          if (felder[formular][key]?.key !== "") {
            if (spesenModus && felder[formular][key]?.art !== "P") {
              return;
            }
            if (spesenModus && felder[formular][key].extra !== "REISEKOSTEN") return;
            if (spesenModus) {
              options.push(
                {
                  label: felder[formular][key]?.name + " Steuerfreie Beträge (" + felder[formular][key]?.key + ")",
                  value: "|" + felder[formular][key]?.key + "|[STEUERFREI]",
                },
                {
                  label: felder[formular][key]?.name + " Steuerpflichtige Beträge ohne Pauschalabzug (" + felder[formular][key]?.key + ")",
                  value: "|" + felder[formular][key]?.key + "|[STEUERPFLICHTIG_OHNE_PAUSCHAL]",
                },
              );
            }
            options.push({
              label: felder[formular][key]?.name + " (" + felder[formular][key]?.key + ")",
              value: "|" + felder[formular][key]?.key + "|",
            });
          }
        })
      : [];

    if (false) {
      options.push({ label: "New Option", value: "newOption" });
    }

    return options;
  };
  function Reset() {
    setOpenLaden(0);
    setOpenSpeichern(0);
    setOpenInfo("");
    setOpenFeld("");
    setOpenRfeld("");
    setOpenDfeld("");
    setOpenSfeld("");
    setFeldKey("");
    setFeldBez("");
    setFeldFormat(0);
    setEingabeInhalt("");
    setEingabeExtra("");
    setEingabeVon(0);
    setEingabeBis(0);
    setEingabeLimit(0);
    setEingabeLabel(false);
    setEingabeNegativ(false);
    setEingabeTyp(0);
    setEingabeLogik(0);
    setLogikArt(0);
    setLogikWert("");
    setLogikLoa("");
    setInfoTyp(0);
    setRfeldTyp(0);
    setMulti(0);
    setEingabePflicht(false);
    setEingabeFibuName("");
    setFeldUeb(0);
    setInfoInhalt("");
    setRfeldInhalt("");
    setRfeldExtra("");
    setRfeldNegativ(false);
    setPfeldInhalt([]);
    setPfeldExtra("");
    setOpenPfeld("");
    setDfeldDb(0);
    setDfeldFeld(0);
    setFormKey(formular);
    setFormBez(formularBez);
    setFormArt(0);
    setHdok(false);
  }
  function ResetGruppe() {
    setOpenGruppe("");
    setGruppeBez("");
    setOpenDatumsGruppe("");
    setGruppeLoop(0);
    SaveLocal("listeGruppe", []);
    setGruppeKey("");
  }
  function LoeschenGruppe() {
    var tmpindex = listeFormular.indexOf(gruppeKey);
    if (tmpindex >= 0) {
      var tmpliste = [...listeFormular];
      tmpliste.splice(tmpindex, 1);
      SaveLocal("listeFormular", tmpliste);
    }
    Reset();
    ResetGruppe();
  }
  function prfFeldUeb(value) {
    if (istInteger(value) === false || value.length > 3) {
      return;
    }
    setFeldUeb(value);
  }
  function DokLaden(dok) {
    setLoading(true);
    const payload = {
      mandant: client,
      program: "FORGEN",
      statement: "DATEI_LADEN",
      key: dok,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        var fileName = "Datei" + ".pdf";
        var contentFile = response.data;
        openFile(fileName, contentFile);
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  }
  function getFile(file) {
    setInfoInhalt(dokfiles.length);
    var tmpliste = dokfiles;
    tmpliste.push(file);
    setDokfiles(tmpliste);
  }
  function handleMandantenClick(dataObject) {
    //Mandantenauswahl für das Kopieren der Datenbank
    setListMandant((prevList) => {
      // Check if the object already exists in the list
      const exists = prevList.some((item) => item.key === dataObject.key);

      if (exists) {
        // Remove the object from the list
        return prevList.filter((item) => item.key !== dataObject.key);
      } else {
        // Add the object to the list
        return [...prevList, dataObject];
      }
    });
  }
  function holeMandantenUndFormulare() {
    let list = "";
    const tmpPgm = zulassung.programs.find((pgm) => {
      return pgm.prg === "FORGEN";
    });

    tmpPgm?.mandanten?.map((dataObject) => {
      list += dataObject.key + ";";
    });

    // setIsLoading(true);

    const payload = {
      mandant: client,
      listeMandanten: listMandant,
      mandanten: list,
      program: "FORGEN",
      statement: "HOLE_MANDANTEN_FORMULARE",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    setOpenMandantSelect(false);
    setListMandant([]);
    apiRequest("POST", "daten", payload, headers, (r) => {
      setMandantenFormulare(r.data.mandanten);
    });
  }
  const copyGruppeAufAnderesMandat = () => {
    const payload = {
      mandant: client,
      listeMandanten: listMandant,
      gruppe: gruppeKey,
      eigenesFormular: formular,
      selectedMandant: listMandant,
      selectedFormular: listFormular,
      program: "FORGEN",
      statement: "COPY_GRUPPE_AUF_ANDERES_MANDAT",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    setOpenMandantSelect(false);
    setListMandant([]);
    apiRequest("POST", "daten", payload, headers, copyCB);
  };
  const copyCB = (response) => {
    if (response.status === 200) {
      showSuccessMessage("Gruppe erfolgreich in anderes Formular kopiert.");
      setOpenMandantFormularSelect(false);
      setListMandant([]);
      setListFormular([]);
    } else {
      showErrorMessage(response.data.message);
    }
  };
  function copyDatabase() {
    //Hier kopieren wir die Datenbank zu den Ausgewählten Mandanten
    setIsLoading(true);
    const payload = {
      mandant: client,
      listeMandanten: listMandant,
      formular: formular,
      program: "FORGEN",
      statement: "COPY_DATABASE",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    setOpenMandantSelect(false);
    setListMandant([]);
    apiRequest("POST", "daten", payload, headers, (r) => responseCopy(r));
  }
  function responseCopy(response) {
    setIsLoading(false);
    if (response.status === 200) {
      if (response.data.bericht) {
        showErrorMessage(
          response.data.bericht.map((item, data) => {
            return `${item}\n`;
          }),
        );
      } else {
        showSuccessMessage("Anlegen der Datenbanken Erfolgreich!");
        init();
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }

  const changePfeldInhalt = (wert, was) => {
    console.log(wert);
    console.log(was);
    var zwis = {};
    if (pfeldInhalt === pfeldExtra || pfeldInhalt === "" || pfeldInhalt === undefined) {
      zwis = {};
    } else {
      zwis = pfeldInhalt;
    }
    zwis[was] = wert;
    setPfeldInhalt({ ...zwis });
  };
  //Renderfunktionen
  function renderHeader() {
    var tmpheader = "";
    if (formular !== "F000") {
      tmpheader = formular + " - " + formularBez;
    } else {
      tmpheader = t("Neues Formular");
    }
    return (
      <Fragment>
        <h2>{tmpheader}</h2>
        <hr align="center" width="100%" height="2px" />
      </Fragment>
    );
  }

  function Plausibilitaetspruefung() {
    var tmpError = [];
    var tmpliste = listeFormular;
    tmpliste.forEach((item, index) => {
      if (item.substr(0, 1) === "S") return;
      if (item.substr(0, 1) === "P") return;
      if (item.substr(0, 1) === "G") {
        var istPflicht = 0;
        var truePflicht = {};
        var tmparray = felder[formular][item].inhalt.split(";");
        tmparray.forEach((item2, index2) => {
          if (item2.substr(0, 1) !== "E") return;
          if (truePflicht[item2] == undefined) truePflicht[item2] = 0;
          if (!felder[formular][item2].antwort || felder[formular][item2].antwort.length === 0) return;
          var keys = Object.keys(felder[formular][item2].antwort);
          keys.forEach((key) => {
            if ((felder[formular][item2].antwort[key] == "" && felder[formular][item2].typ !== "09") || felder[formular][item2].antwort[key] === "") return;
            istPflicht = Math.max(Number(key), istPflicht);
            if (felder[formular][item2].pflicht === "1" && Number(key) - truePflicht[item2] <= 1) truePflicht[item2] = Number(key);
          });
        });
        var keys = Object.keys(truePflicht);
        keys.forEach((key) => {
          if (felder[formular][key].pflicht !== "1") return;
          if (istPflicht > truePflicht[key]) {
            tmpError.push(key + istPflicht.toString());
          }
        });
      }
      if (felder[formular][item].logik === "03") {
        if (!felder[formular][item].antwort || felder[formular][item].antwort === "") {
          if (felder[formular][item].logikwert.includes("=")) {
            let bedingung = felder[formular][item].logikwert.split("=");
            bedingung[0] = bedingung[0].replaceAll("|", "").replaceAll(" ", "");
            bedingung[1] = bedingung[1].replace(/\s/g, "");
            if (felder[formular][bedingung[0]].typ === "08") {
              //Checkboxgruppe
              if (felder[formular][bedingung[0]]?.antwort) {
                if (felder[formular][bedingung[0]]?.antwort[parseInt(bedingung[1]) - 1] === "1") {
                  tmpError.push(item);
                }
              }
            }
            if (felder[formular][bedingung[0]]?.antwort === bedingung[1]) {
              tmpError.push(item);
            }
          } else if (felder[formular][item].logikwert.includes("<>")) {
            let bedingung = felder[formular][item].logikwert.split("<>");
            bedingung[0] = bedingung[0].replaceAll("|", "").replaceAll(" ", "");
            if (felder[formular][bedingung[0]]?.antwort !== bedingung[1]) {
              tmpError.push(item);
            }
          } else if (felder[formular][item].logikwert.includes("<")) {
          } else if (felder[formular][item].logikwert.includes(">")) {
          }
        }
      }
      if (felder[formular][item].pflicht !== "1") return;
      var typ = felder[formular][item].typ;
      if (typ === "01") {
        if (!felder[formular][item].antwort || felder[formular][item].antwort === "") tmpError.push(item);
      }
      if (typ === "02") {
        if (!felder[formular][item].antwort || felder[formular][item].antwort === "") tmpError.push(item);
      }
      if (typ === "03") {
        if (!felder[formular][item].antwort || felder[formular][item].antwort === "") tmpError.push(item);
      }
      if (typ === "04") {
        if (!felder[formular][item].antwort || felder[formular][item].antwort === "") tmpError.push(item);
      }
      if (typ === "05") {
        if (!felder[formular][item].antwort || felder[formular][item].antwort === "0") tmpError.push(item);
      }
      if (typ === "06") {
        if (!felder[formular][item].antwort || felder[formular][item].antwort === "") tmpError.push(item);
      }
      if (typ === "07") {
        if (!felder[formular][item].antwort || felder[formular][item].antwort === "") tmpError.push(item);
      }
      if (typ === "08") {
        if (!felder[formular][item].antwort) {
          tmpError.push(item);
        } else {
          var check = 0;
          const items = Object.values(felder[formular][item].antwort);
          items.forEach((item) =>
            Object.entries(item).forEach(([key, value]) => {
              if (value === "1") check = 1;
            }),
          );
          if (check === 0) tmpError.push(item);
        }
      }
    });
    setFelderError(tmpError);
    if (tmpError.length > 0) {
      showErrorMessage(t("Bitte füllen Sie alle Pflichtfelder aus"));
      return 1;
    } else {
      showSuccessMessage(t("Formular erfolgreich geprüft"));
      return 0;
    }
  }

  function renderLaden() {
    return (
      <ResponsiveDialog
        title={t("Formular laden")}
        open={openLaden === 1}
        setOpen={() => setOpenLaden(0)}
        actionButton={
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item>
              <Button variant="outlined" color="primary" onClick={() => Reset()}>
                {t("Abbrechen")}
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" color="primary" onClick={() => LadenFormular()}>
                {t("Laden")}
              </Button>
            </Grid>
          </Grid>
        }
      >
        <Box p={2}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label={t("Formular")}
                value={ladenFormular}
                select
                onChange={(e) => setLadenFormular(e.target.value)}
              >
                {formulare.map((item, index) => {
                  return (
                    <MenuItem key={index} value={index} index={index}>
                      {item.key + " - " + item.name}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
          </Grid>
        </Box>
      </ResponsiveDialog>
    );
  }
  function renderSpeichern() {
    return (
      <ResponsiveDialog
        title={t("Formular speichern")}
        open={openSpeichern === 1}
        setOpen={() => Reset()}
        actionButton={
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item>
              <Button variant="outlined" color="primary" onClick={() => Reset()}>
                {t("Abbrechen")}
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" color="primary" onClick={() => SpeichernFormular()}>
                {t("Speichern")}
              </Button>
            </Grid>
          </Grid>
        }
      >
        <Box p={2}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label={t("Formular")}
                value={formKey}
                select
                onChange={(e) => {
                  setFormKey(e.target.value);
                  felder[e.target.value][e.target.value] ? setFormBez(felder[e.target.value][e.target.value].name) : setFormBez("");
                }}
              >
                <MenuItem key={""} value={"F000"} index={-1}>
                  {"Neues Formular"}
                </MenuItem>
                {formulare.map((item, index) => {
                  return (
                    <MenuItem key={item.key} value={item.key} index={index}>
                      {item.key + " - " + item.name}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth size="small" variant="outlined" label={t("Kennung")} value={formKey} disabled />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth size="small" variant="outlined" label={t("Bezeichnung")} value={formBez} onChange={(e) => setFormBez(e.target.value)} />
            </Grid>
            {global === "J" && formKey === "F000" && (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  select
                  size="small"
                  variant="outlined"
                  label={t("Formularart")}
                  value={formArt}
                  onChange={(e) => setFormArt(e.target.value)}
                >
                  <MenuItem key={0} value={0} index={0}>
                    {"individuell"}
                  </MenuItem>
                  <MenuItem key={1} value={1} index={1}>
                    {"global"}
                  </MenuItem>
                </TextField>
              </Grid>
            )}
            {formArt !== 1 && formKey.substr(0, 1) === "F" && (
              <Fragment>
                {formulare[formulare.findIndex((i) => i.key === formKey)] &&
                  formulare[formulare.findIndex((i) => i.key === formKey)].hdok &&
                  Number(formulare[formulare.findIndex((i) => i.key === formKey)].hdok) !== 0 && (
                    <Grid item xs={12}>
                      <Typography>{t("Ablagenamen bereits hinterlegt")}</Typography>
                      <Typography>{"Ablagenamenkey: " + formulare[formulare.findIndex((i) => i.key === formKey)].hdok}</Typography>
                    </Grid>
                  )}
                {(!formulare[formulare.findIndex((i) => i.key === formKey)] ||
                  !formulare[formulare.findIndex((i) => i.key === formKey)].hdok ||
                  Number(formulare[formulare.findIndex((i) => i.key === formKey)].hdok) === 0) && (
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                          checkedIcon={<CheckBoxIcon fontSize="small" />}
                          checked={hdok}
                          onChange={(e) => setHdok(e.target.checked)}
                        />
                      }
                      label={"Ablagenamen automatisch anlegen"}
                    />
                  </Grid>
                )}
              </Fragment>
            )}
          </Grid>
        </Box>
      </ResponsiveDialog>
    );
  }
  function renderTagesOptions() {
    return (
      <>
        <FormControlLabel
          control={
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              checked={logikWert.includes("FZ;")}
              onChange={(e) => {
                if (e.target.checked) {
                  setLogikWert(logikWert + "FZ;");
                } else {
                  setLogikWert(logikWert.replace("FZ;", ""));
                }
              }}
            />
          }
          label={"Tage mit Fehlzeit"}
        />
        <FormControlLabel
          control={
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              checked={logikWert.includes("MO;")}
              onChange={(e) => {
                if (e.target.checked) {
                  setLogikWert(logikWert + "MO;");
                } else {
                  setLogikWert(logikWert.replace("MO;", ""));
                }
              }}
            />
          }
          label={"Montag"}
        />
        <FormControlLabel
          control={
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              checked={logikWert.includes("DI;")}
              onChange={(e) => {
                if (e.target.checked) {
                  setLogikWert(logikWert + "DI;");
                } else {
                  setLogikWert(logikWert.replace("DI;", ""));
                }
              }}
            />
          }
          label={"Dienstag"}
        />
        <FormControlLabel
          control={
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              checked={logikWert.includes("MI;")}
              onChange={(e) => {
                if (e.target.checked) {
                  setLogikWert(logikWert + "MI;");
                } else {
                  setLogikWert(logikWert.replace("MI;", ""));
                }
              }}
            />
          }
          label={"Mittwoch"}
        />
        <FormControlLabel
          control={
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              checked={logikWert.includes("DO;")}
              onChange={(e) => {
                if (e.target.checked) {
                  setLogikWert(logikWert + "DO;");
                } else {
                  setLogikWert(logikWert.replace("DO;", ""));
                }
              }}
            />
          }
          label={"Donnerstag"}
        />
        <FormControlLabel
          control={
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              checked={logikWert.includes("FR;")}
              onChange={(e) => {
                if (e.target.checked) {
                  setLogikWert(logikWert + "FR;");
                } else {
                  setLogikWert(logikWert.replace("FR;", ""));
                }
              }}
            />
          }
          label={"Freitag"}
        />
        <FormControlLabel
          control={
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              checked={logikWert.includes("SA;")}
              onChange={(e) => {
                if (e.target.checked) {
                  setLogikWert(logikWert + "SA;");
                } else {
                  setLogikWert(logikWert.replace("SA;", ""));
                }
              }}
            />
          }
          label={"Samstag"}
        />
        <FormControlLabel
          control={
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              checked={logikWert.includes("SO;")}
              onChange={(e) => {
                if (e.target.checked) {
                  setLogikWert(logikWert + "SO;");
                } else {
                  setLogikWert(logikWert.replace("SO;", ""));
                }
              }}
            />
          }
          label={"Sonntag"}
        />
        <FormControlLabel
          control={
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              checked={logikWert.includes("MO-FT;")}
              onChange={(e) => {
                if (e.target.checked) {
                  setLogikWert(logikWert + "MO-FT;");
                } else {
                  setLogikWert(logikWert.replace("MO-FT;", ""));
                }
              }}
            />
          }
          label={"Montag (Feiertage)"}
        />
        <FormControlLabel
          control={
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              checked={logikWert.includes("DI-FT;")}
              onChange={(e) => {
                if (e.target.checked) {
                  setLogikWert(logikWert + "DI-FT;");
                } else {
                  setLogikWert(logikWert.replace("DI-FT;", ""));
                }
              }}
            />
          }
          label={"Dienstag (Feiertage)"}
        />
        <FormControlLabel
          control={
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              checked={logikWert.includes("MI-FT;")}
              onChange={(e) => {
                if (e.target.checked) {
                  setLogikWert(logikWert + "MI-FT;");
                } else {
                  setLogikWert(logikWert.replace("MI-FT;", ""));
                }
              }}
            />
          }
          label={"Mittwoch (Feiertage)"}
        />
        <FormControlLabel
          control={
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              checked={logikWert.includes("DO-FT;")}
              onChange={(e) => {
                if (e.target.checked) {
                  setLogikWert(logikWert + "DO-FT;");
                } else {
                  setLogikWert(logikWert.replace("DO-FT;", ""));
                }
              }}
            />
          }
          label={"Donnerstag (Feiertage)"}
        />
        <FormControlLabel
          control={
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              checked={logikWert.includes("FR-FT;")}
              onChange={(e) => {
                if (e.target.checked) {
                  setLogikWert(logikWert + "FR-FT;");
                } else {
                  setLogikWert(logikWert.replace("FR-FT;", ""));
                }
              }}
            />
          }
          label={"Freitag (Feiertage)"}
        />
        <FormControlLabel
          control={
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              checked={logikWert.includes("SA-FT;")}
              onChange={(e) => {
                if (e.target.checked) {
                  setLogikWert(logikWert + "SA-FT;");
                } else {
                  setLogikWert(logikWert.replace("SA-FT;", ""));
                }
              }}
            />
          }
          label={"Samstag (Feiertage)"}
        />
        <FormControlLabel
          control={
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              checked={logikWert.includes("SO-FT;")}
              onChange={(e) => {
                if (e.target.checked) {
                  setLogikWert(logikWert + "SO-FT;");
                } else {
                  setLogikWert(logikWert.replace("SO-FT;", ""));
                }
              }}
            />
          }
          label={"Sonntag (Feiertage)"}
        />
      </>
    );
  }
  function NeueEingabe() {
    return (
      <ResponsiveDialog
        title={t("Eingabe")}
        open={openFeld !== ""}
        setOpen={() => setOpenFeld("")}
        actionButton={
          <Fragment>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <Button variant="outlined" color="primary" onClick={() => Reset()}>
                  {t("Abbrechen")}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    openGruppe !== "" || openDatumsGruppe !== ""
                      ? SpeichernEingabe(listeGruppe, "listeGruppe")
                      : SpeichernEingabe(listeFormular, "listeFormular");
                  }}
                >
                  {t("Speichern")}
                </Button>
              </Grid>
              {openFeld === "loaded" && (
                <Grid item>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      confirm({
                        text: "Sind Sie sicher, dass Sie das Eingabefeld löschen möchten ?",
                        title: "Löschen",
                        buttons: "YESNO",
                      })
                        .then(() => {
                          if (openGruppe !== "" || openDatumsGruppe !== "") {
                            LoeschenFeld(listeGruppe, "listeGruppe");
                          } else {
                            LoeschenFeld(listeFormular, "listeFormular");
                          }
                        })
                        .catch((antwort) => {});
                    }}
                  >
                    {t("Löschen")}
                  </Button>
                </Grid>
              )}
            </Grid>
          </Fragment>
        }
      >
        <Box p={2}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12}>
              <TextField fullWidth size="small" variant="outlined" label={t("Kennung")} value={feldKey} disabled />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label={t("Bezeichnung")}
                value={feldBez}
                onChange={(e) => setFeldBez(e.target.value)}
                autoFocus
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label={t("Eingabentyp")}
                value={eingabeTyp}
                select
                onChange={(e) => setEingabeTyp(e.target.value)}
              >
                {feldtyp.map((item, index) => {
                  // if (item.key === "08" && openGruppe !== "") return <div></div>;
                  return (
                    <MenuItem key={index} value={index} index={index}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
            {feldtyp[eingabeTyp] && feldtyp[eingabeTyp].key === "11" && (
              <Grid item xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  variant="outlined"
                  label={t("Betragswährung")}
                  value={eingabeExtra}
                  onChange={(e) => setEingabeExtra(e.target.value)}
                />
              </Grid>
            )}
            {feldtyp[eingabeTyp] && (feldtyp[eingabeTyp].key === "06" || feldtyp[eingabeTyp].key === "08" || feldtyp[eingabeTyp].key === "13") && (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  type="text"
                  size="small"
                  variant="outlined"
                  label={t("Auswahl")}
                  multiline
                  value={eingabeInhalt}
                  onChange={(e) => setEingabeInhalt(e.target.value)}
                />
              </Grid>
            )}
            {feldtyp[eingabeTyp] && (feldtyp[eingabeTyp].key === "02" || feldtyp[eingabeTyp].key === "10" || feldtyp[eingabeTyp].key === "15") && (
              <Grid item xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  variant="outlined"
                  label={t("Zahlenrange von")}
                  value={eingabeVon}
                  type={feldtyp[eingabeTyp].key !== "10" ? "number" : ""}
                  onChange={(e) => Von(e.target.value, feldtyp[eingabeTyp].key)}
                />
              </Grid>
            )}
            {feldtyp[eingabeTyp] && (feldtyp[eingabeTyp].key === "02" || feldtyp[eingabeTyp].key === "10" || feldtyp[eingabeTyp].key === "15") && (
              <Grid item xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  variant="outlined"
                  label={t("Zahlenrange bis")}
                  value={eingabeBis}
                  type={feldtyp[eingabeTyp].key !== "10" ? "number" : ""}
                  onChange={(e) => Bis(e.target.value, feldtyp[eingabeTyp].key)}
                />
              </Grid>
            )}
            {feldtyp[eingabeTyp] && feldtyp[eingabeTyp].key === "11" && (
              <Grid item xs={12}>
                <BetragInput
                  size="small"
                  fullWidth
                  variant="outlined"
                  label={t("Zahlenrange von")}
                  value={eingabeVon ? Number(eingabeVon) : 0}
                  onChange={(e) => setEingabeVon(e)}
                />
              </Grid>
            )}
            {feldtyp[eingabeTyp] && feldtyp[eingabeTyp].key === "11" && (
              <Grid item xs={12}>
                <BetragInput
                  size="small"
                  fullWidth
                  variant="outlined"
                  label={t("Zahlenrange bis")}
                  value={eingabeBis ? Number(eingabeBis) : 0}
                  onChange={(e) => setEingabeBis(e)}
                />
              </Grid>
            )}
            {feldtyp[eingabeTyp] && (feldtyp[eingabeTyp].key === "01" || feldtyp[eingabeTyp].key === "07") && (
              <Grid item xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  variant="outlined"
                  label={t("Character Limit")}
                  value={eingabeLimit}
                  type="number"
                  onChange={(e) => setEingabeLimit(e.target.value)}
                />
              </Grid>
            )}
            {feldtyp[eingabeTyp] && feldtyp[eingabeTyp].key === "11" && (
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                      checkedIcon={<CheckBoxIcon fontSize="small" />}
                      checked={eingabeNegativ}
                      onChange={(e) => setEingabeNegativ(e.target.checked)}
                    />
                  }
                  label={"Negative Beträge erlauben"}
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    checked={eingabeLabel}
                    onChange={(e) => setEingabeLabel(e.target.checked)}
                  />
                }
                label={"Label anzeigen"}
              />
            </Grid>
            {feldtyp[eingabeTyp] && (feldtyp[eingabeTyp].key === "01" || feldtyp[eingabeTyp].key === "07") && (
              <Grid item xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  variant="outlined"
                  label={t("Hilfetext")}
                  value={eingabeInhalt}
                  onChange={(e) => setEingabeInhalt(e.target.value)}
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label={t("Textformat")}
                value={feldFormat}
                select
                onChange={(e) => setFeldFormat(e.target.value)}
              >
                {format.map((item, index) => {
                  return (
                    <MenuItem key={index} value={index} index={index}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
            {feldtyp[eingabeTyp] && feldtyp[eingabeTyp].key === "05" && (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  type="text"
                  size="small"
                  variant="outlined"
                  label={t("Zusätzlicher Text rechts")}
                  value={eingabeInhalt}
                  onChange={(e) => setEingabeInhalt(e.target.value)}
                />
              </Grid>
            )}
            {feldtyp[eingabeTyp] && feldtyp[eingabeTyp].key === "08"  && (
              <Grid item xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  variant="outlined"
                  label={t("Multiauswahl")}
                  value={multi ? multi : 0}
                  select
                  onChange={(e) => setMulti(e.target.value)}
                >
                  {multiauswahl.map((item, index) => {
                    return (
                      <MenuItem key={index} value={index} index={index}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
            )}
            {/*(feldtyp[eingabeTyp]&&(feldtyp[eingabeTyp].key==="08"&&openGruppe===""))&&
              <Fragment>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    type="text"
                    size="small"
                    variant="outlined"
                    label={t("Zusätzlicher Text rechts")}
                    value={eingabeInhalt}
                    onChange={(e=>setEingabeInhalt(e.target.value))}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    type="text"
                    size="small"
                    variant="outlined"
                    label={t("Zusätzlicher Text rechts")}
                    value={eingabeInhalt}
                    onChange={(e=>setEingabeInhalt(e.target.value))}
                  />
                </Grid>
              </Fragment>
          */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    checked={eingabePflicht}
                    onChange={(e) => setEingabePflicht(e.target.checked)}
                  />
                }
                label={"Pflichtfeld"}
              />
            </Grid>
            {feldtyp[eingabeTyp]?.key === "15" ? (
              <Grid item xs={12}>
                {" "}
                {renderTagesOptions()}
              </Grid>
            ) : (
              <>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    label={t("Logik")}
                    value={eingabeLogik}
                    select
                    onChange={(e) => setEingabeLogik(e.target.value)}
                  >
                    {feldlogik.map((item, index) => {
                      return (
                        <MenuItem key={index} value={index} index={index}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>
                {feldlogik[eingabeLogik] && feldlogik[eingabeLogik].key === "02" && (
                  <Fragment>
                    <Grid item xs={12}>
                      {/* <Autocomplete
                        noOptionsText={t("kein Eintrag gefunden")}
                        onChange={(event, newValue) => {
                          setLogikLoa(newValue?.key);
                          console.log(newValue?.key);
                        }}
                        value={logikLoa !== -1 ? logikLoa : ""}
                        options={logikloas?.map((loa, index) => ({ key: index, name: loa.name }))}
                        getOptionLabel={(option) => option.name || ""}
                        isOptionEqualToValue={(option, value) => option.key === value}
                        renderInput={(params) => (
                          <TextField
                            label={t("Lohnart")}
                            autoFocus
                            {...params}
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        )}
                      /> */}
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label={t("Lohnart")}
                        select
                        value={logikLoa}
                        onChange={(e) => setLogikLoa(e.target.value)}
                      >
                        {logikloas.map((item, index) => {
                          return (
                            <MenuItem key={index} value={index} index={index}>
                              {item.name}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label={t("Übernahmeart")}
                        value={logikArt}
                        select
                        onChange={(e) => setLogikArt(e.target.value)}
                      >
                        {logikarten.map((item, index) => {
                          return (
                            <MenuItem key={index} value={index} index={index}>
                              {item.name}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        type="number"
                        size="small"
                        variant="outlined"
                        label={t("Wert")}
                        value={logikWert}
                        onChange={(e) => setLogikWert(e.target.value)}
                      />
                    </Grid>
                  </Fragment>
                )}
                       {feldlogik[eingabeLogik] && feldlogik[eingabeLogik].key === "03" && (
                  <Fragment>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label={t("Pflichtbedingung")}
                        value={logikWert}
                        onChange={(e) => setLogikWert(e.target.value)}
                      ></TextField>
                    </Grid>
                  </Fragment>
                )}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    type="text"
                    size="small"
                    variant="outlined"
                    label={t("Übergabekey")}
                    value={feldUeb}
                    onChange={(e) => prfFeldUeb(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    label={t("Fibu Extrafeld")}
                    value={eingabeFibuName}
                    select
                    onChange={(e) => setEingabeFibuName(e.target.value)}
                  >
                    {console.log(fibuZusatzfelder)}
                    {fibuZusatzfelder.map((item, index) => {
                      return (
                        <MenuItem key={item.key} value={item.key} index={index}>
                          {item.name + " (" + item.key + ")"}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                  {/* <TextField
                    fullWidth
                    type="text"
                    size="small"
                    variant="outlined"
                    label={t("Fibu export Name")}
                    value={eingabeFibuName}
                    onChange={(e) => setEingabeFibuName(e.target.value)}
                  /> */}
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      </ResponsiveDialog>
    );
  }
  function NeueInfo() {
    return (
      <ResponsiveDialog
        title={t("Info")}
        open={openInfo !== ""}
        setOpen={() => {
          setOpenInfo("");
        }}
        actionButton={
          <Fragment>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <Button variant="outlined" color="primary" onClick={() => Reset()}>
                  {t("Abbrechen")}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    openGruppe !== "" ? SpeichernInfo(listeGruppe, "listeGruppe") : SpeichernInfo(listeFormular, "listeFormular");
                  }}
                >
                  {t("Speichern")}
                </Button>
              </Grid>
              {openInfo === "loaded" && (
                <Grid item>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      confirm({
                        text: "Sind Sie sicher, dass Sie das Infofeld löschen möchten ?",
                        title: "Löschen",
                        buttons: "YESNO",
                      })
                        .then(() => {
                          if (openGruppe !== "") {
                            LoeschenFeld(listeGruppe, "listeGruppe");
                          } else {
                            LoeschenFeld(listeFormular, "listeFormular");
                          }
                        })
                        .catch((antwort) => {});
                    }}
                  >
                    {t("Löschen")}
                  </Button>
                </Grid>
              )}
            </Grid>
          </Fragment>
        }
      >
        <Box p={2}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12}>
              <TextField size="small" fullWidth variant="outlined" label={t("Kennung")} value={feldKey} disabled />
            </Grid>
            <Grid item xs={12}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label={t("Bezeichnung")}
                value={feldBez}
                disabled={infoTyp === 7}
                onChange={(e) => setFeldBez(e.target.value)}
                autoFocus
              />
            </Grid>
            <Grid item xs={12}>
              <TextField size="small" fullWidth variant="outlined" label={t("Infoart")} value={infoTyp} select onChange={(e) => setInfoTyp(e.target.value)}>
                {infotyp.map((item, index) => {
                  return (
                    <MenuItem key={index} value={index} index={index}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
            {infotyp[infoTyp] && infotyp[infoTyp].key === "07" && (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label={t("Systeminfo")}
                  select
                  value={infoSysinfo}
                  onChange={(e) => setInfoSysinfo(e.target.value)}
                >
                  {sysinfo.map((item, index) => {
                    return (
                      <MenuItem key={index} value={index} index={index}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
            )}
            {infotyp[infoTyp] && infotyp[infoTyp].key !== "06" && infotyp[infoTyp].key !== "07" && (
              <Fragment>
                <Grid item xs={12}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    label={t("Infotext")}
                    value={infoInhalt}
                    onChange={(e) => setInfoInhalt(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    label={t("Textformat")}
                    value={feldFormat}
                    select
                    onChange={(e) => setFeldFormat(e.target.value)}
                  >
                    {format.map((item, index) => {
                      return (
                        <MenuItem key={index} value={index} index={index}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>
              </Fragment>
            )}
            {infotyp[infoTyp] && infotyp[infoTyp].key === "06" && openGruppe === "" && (
              <Grid item xs={12}>
                {infoInhalt && infoInhalt.length > 5 ? (
                  <Fragment>
                    <Button variant="outlined" onClick={() => DokLaden(infoInhalt)}>
                      {"Datei anzeigen"}
                    </Button>
                    <IconButton onClick={() => setInfoInhalt("")}>
                      <DeleteIcon />
                    </IconButton>
                  </Fragment>
                ) : (
                  <TextField size="small" type="file" onChange={(e) => getFile(e.target.files[0])} />
                )}
              </Grid>
            )}
          </Grid>
        </Box>
      </ResponsiveDialog>
    );
  }
  function NeueGruppe() {
    return (
      <ResponsiveDialog
        title={t("Gruppe")}
        open={openGruppe !== ""}
        setOpen={() => {
          setOpenGruppe("");
          ResetGruppe();
        }}
        actionButton={
          <Grid container spacing={2} justifyContent="flex-end">
            {listeGruppe && (
              <Fragment>
                <Grid item>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setFeldKey("E" + pad(maxEingabe[formular], 3).toString());
                      setOpenFeld("empty");
                    }}
                  >
                    {t("Neue Eingabe")}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setFeldKey("I" + pad(maxInfo[formular], 3).toString());
                      setOpenInfo("empty");
                      setFeldBez("Infotext");
                    }}
                  >
                    {t("Neue Info")}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setFeldKey("R" + pad(maxRfeld[formular], 3).toString());
                      setOpenRfeld("empty");
                    }}
                  >
                    {t("Neues Rechenfeld")}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setFeldKey("D" + pad(maxDfeld[formular], 3).toString());
                      setOpenDfeld("empty");
                    }}
                  >
                    {t("Neues Datenbankfeld")}
                  </Button>
                </Grid>
              </Fragment>
            )}
            <Grid item>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  Reset();
                  ResetGruppe();
                }}
              >
                {t("Abbrechen")}
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" color="primary" onClick={() => SpeichernGruppe()}>
                {t("Speichern")}
              </Button>
            </Grid>
            {openGruppe === "loaded" && (
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    confirm({
                      text: "Sind Sie sicher, dass Sie die Gruppe löschen möchten ?",
                      title: "Löschen",
                      buttons: "YESNO",
                    })
                      .then(() => {
                        LoeschenGruppe();
                      })
                      .catch((antwort) => {});
                  }}
                >
                  {t("Löschen")}
                </Button>
              </Grid>
            )}
          </Grid>
        }
      >
        <Box p={2}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12}>
              <TextField size="small" fullWidth variant="outlined" label={t("Kennung")} value={gruppeKey} disabled />
            </Grid>
            <Grid item xs={12}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label={t("Bezeichnung")}
                value={gruppeBez}
                onChange={(e) => setGruppeBez(e.target.value)}
                autoFocus
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label={t("maximale Anzahl Wiederholungen")}
                type="number"
                value={gruppeLoop}
                onChange={(e) => setGruppeLoop(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Gruppe
                felder={felder}
                formular={formular}
                id={gruppeKey}
                liste={listeGruppe}
                FeldBearbeiten={FeldBearbeiten}
                CopyFeld={CopyFeld}
                ChangeGruppe={(l) => SaveLocal("listeGruppe", l)}
              />
            </Grid>
            {(clientServer === "ecintern" || clientServer === "admin") && (
              <Fragment>
                <Grid item>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      holeMandantenUndFormulare();
                      setOpenMandantFormularSelect(true);
                    }}
                  >
                    {t("Gruppe in anderes Formular kopieren")}
                  </Button>
                </Grid>
              </Fragment>
            )}
          </Grid>
        </Box>
      </ResponsiveDialog>
    );
  }
  function NeueDatumsGruppe() {
    return (
      <ResponsiveDialog
        title={t("DatumsGruppe")}
        open={openDatumsGruppe !== ""}
        setOpen={() => {
          setOpenDatumsGruppe("");
          ResetGruppe();
        }}
        actionButton={
          <Grid container spacing={2} justifyContent="flex-end">
            {listeGruppe && listeGruppe.length < 12 && (
              <Fragment>
                <Grid item>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setFeldKey("E" + pad(maxEingabe[formular], 3).toString());
                      setOpenFeld("empty");
                    }}
                  >
                    {t("Neue Eingabe")}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setFeldKey("I" + pad(maxInfo[formular], 3).toString());
                      setOpenInfo("empty");
                      setFeldBez("Infotext");
                    }}
                  >
                    {t("Neue Info")}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setFeldKey("R" + pad(maxRfeld[formular], 3).toString());
                      setOpenRfeld("empty");
                    }}
                  >
                    {t("Neues Rechenfeld")}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setFeldKey("D" + pad(maxDfeld[formular], 3).toString());
                      setOpenDfeld("empty");
                    }}
                  >
                    {t("Neues Datenbankfeld")}
                  </Button>
                </Grid>
              </Fragment>
            )}
            <Grid item>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  Reset();
                  ResetGruppe();
                }}
              >
                {t("Abbrechen")}
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" color="primary" onClick={() => SpeichernDatumsgruppe()}>
                {t("Speichern")}
              </Button>
            </Grid>
            {openDatumsGruppe === "loaded" && (
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    confirm({
                      text: "Sind Sie sicher, dass Sie die Gruppe löschen möchten ?",
                      title: "Löschen",
                      buttons: "YESNO",
                    })
                      .then(() => {
                        LoeschenGruppe();
                      })
                      .catch((antwort) => {});
                  }}
                >
                  {t("Löschen")}
                </Button>
              </Grid>
            )}
          </Grid>
        }
      >
        <Box p={2}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12}>
              <TextField size="small" fullWidth variant="outlined" label={t("Kennung")} value={gruppeKey} disabled />
            </Grid>
            <Grid item xs={12}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label={t("Bezeichnung")}
                value={gruppeBez}
                onChange={(e) => setGruppeBez(e.target.value)}
                autoFocus
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label={t("Zeiteinheit")}
                select
                value={gruppeLoop}
                onChange={(e) => setGruppeLoop(e.target.value)}
              >
                <MenuItem value="Woche">Woche</MenuItem>
                <MenuItem value="Monat">Monat</MenuItem>
              </TextField>
            </Grid>
            {/* <Grid item xs={12}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label={t("maximale Anzahl Wiederholungen")}
                type="number"
                value={gruppeLoop}
                onChange={(e) => setGruppeLoop(e.target.value)}
              />
            </Grid> */}
            <Grid item xs={12}>
              <Gruppe
                felder={felder}
                formular={formular}
                id={gruppeKey}
                liste={listeGruppe}
                FeldBearbeiten={FeldBearbeiten}
                CopyFeld={CopyFeld}
                ChangeGruppe={(l) => SaveLocal("listeGruppe", l)}
              />
            </Grid>
            {(clientServer === "ecintern" || clientServer === "admin") && (
              <Fragment>
                <Grid item>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      holeMandantenUndFormulare();
                      setOpenMandantFormularSelect(true);
                    }}
                  >
                    {t("Gruppe in anderes Formular kopieren")}
                  </Button>
                </Grid>
              </Fragment>
            )}
          </Grid>
        </Box>
      </ResponsiveDialog>
    );
  }

  function NeuesRechenfeld() {
    return (
      <ResponsiveDialog
        title={t("Rechenfeld")}
        open={openRfeld !== ""}
        setOpen={() => setOpenRfeld("")}
        actionButton={
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item>
              <Button variant="outlined" color="primary" onClick={() => Reset()}>
                {t("Abbrechen")}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  openGruppe !== "" ? SpeichernRfeld(listeGruppe, "listeGruppe") : SpeichernRfeld(listeFormular, "listeFormular");
                }}
              >
                {t("Speichern")}
              </Button>
            </Grid>
            {openRfeld === "loaded" && (
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    confirm({
                      text: "Sind Sie sicher, dass Sie das Rechenfeld löschen möchten ?",
                      title: "Löschen",
                      buttons: "YESNO",
                    })
                      .then(() => {
                        if (openGruppe !== "") {
                          LoeschenFeld(listeGruppe, "listeGruppe");
                        } else {
                          LoeschenFeld(listeFormular, "listeFormular");
                        }
                      })
                      .catch((antwort) => {});
                  }}
                >
                  {t("Löschen")}
                </Button>
              </Grid>
            )}
          </Grid>
        }
      >
        <Box p={2}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12}>
              <TextField fullWidth size="small" variant="outlined" label={t("Kennung")} value={feldKey} disabled />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label={t("Bezeichnung")}
                value={feldBez}
                onChange={(e) => setFeldBez(e.target.value)}
                autoFocus
              />
            </Grid>
            <Grid item xs={12}>
              <TextField size="small" fullWidth variant="outlined" label={t("Feldart")} value={rfeldTyp} select onChange={(e) => setRfeldTyp(e.target.value)}>
                {rfeldtyp.map((item, index) => {
                  return (
                    <MenuItem key={index} value={index} index={index}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                multiple={true}
                fullWidth={true}
                onChange={(event, newValue) => {
                  const keys = newValue.map((value) => {
                    if (typeof value === "string") {
                      return value;
                    } else {
                      return value.value;
                    }
                  });
                  setRfeldInhalt(keys.join(";"));
                }}
                value={rfeldInhalt !== "" ? rfeldInhalt.split(";") : []}
                filterOptions={(options, params) => {
                  if (options[0] === undefined) {
                    if (params.inputValue !== "") {
                      return [
                        {
                          value: params.inputValue,
                          label: `"${params.inputValue}" hinzufügen`,
                        },
                      ];
                    } else {
                      return [];
                    }
                  }
                  const optionen = options?.filter((e) => e.label.toUpperCase().includes(params.inputValue.toUpperCase()));
                  if (params.inputValue !== "") {
                    optionen.push({
                      value: params.inputValue,
                      label: `"${params.inputValue}" hinzufügen`,
                    });
                  }
                  return optionen;
                }}
                id="inhalt"
                options={getRechenFeldOptions()}
                getOptionLabel={(option) => {
                  if (typeof option === "string") {
                    return option;
                  }
                  if (option.value) {
                    return option.value;
                  }
                  return option.label;
                }}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  return (
                    <li key={key} {...optionProps}>
                      {option.label}
                    </li>
                  );
                }}
                noOptionsText="Keine Felder gefunden"
                renderInput={(params) => <TextField {...params} label="Inhalt" />}
              />
              {/* <Autocomplete
                onChange={(event, newValue) => {
                  // changeWerte(count, "location", newValue)
                }}
                // options={felder[formular]?.map((ort) => (
                //   { label: ort.bez, value: ort.key }
                // ))}
                options={felder[formular] !== undefined ? Object.keys(felder[formular]).map((key) => (
                  { label: felder[formular][key]?.name + " (" + felder[formular][key]?.key + ")", value: felder[formular][key]?.key }
                )) : []}

                // options={[{ label: "test", value: "1" }, { label: "test2", value: "2" }]}
                // disabled={lock === true}
                // value={tage[count]["location"]}
                fullWidth
                multiple={true}
                renderInput={(params) => <TextField {...params} label="" placeholder="Suchen" />} /> */}
              {rfeldInhalt?.replace(/;/g, "")}
              {/* <TextField
                size="small"
                fullWidth
                variant="outlined"
                label={t("Inhalt")}
                value={rfeldInhalt}
                onChange={(e) => setRfeldInhalt(e.target.value)}
              /> */}
            </Grid>
            <Grid item xs={12}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label={t("Betragswährung")}
                value={rfeldExtra}
                onChange={(e) => setRfeldExtra(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    checked={rfeldNegativ}
                    onChange={(e) => setRfeldNegativ(e.target.checked)}
                  />
                }
                label={"Negative Werte auf 0 aufrunden"}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label={t("Logik")}
                value={eingabeLogik}
                select
                onChange={(e) => setEingabeLogik(e.target.value)}
              >
                {feldlogik.map((item, index) => {
                  return (
                    <MenuItem key={index} value={index} index={index}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
            {feldlogik[eingabeLogik] && feldlogik[eingabeLogik].key === "02" && (
              <Fragment>
                <Grid item xs={12}>
                  {/* <Autocomplete
                    noOptionsText={t("kein Eintrag gefunden")}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setLogikLoa(newValue.value);
    
                      } else {
                        setLogikLoa(null); 
                       
                      }
                    }}
                    value={logikLoa}
                    options={logikloas?.map((loa, index) => ({ value: index, name: loa.name }))}
                    getOptionLabel={(option) => option.name || ""}
                    isOptionEqualToValue={(option, value) => option.value === value} // Compare keys
                    renderInput={(params) => (
                      <TextField
                        label={t("Lohnart")}
                        autoFocus
                        {...params}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  /> */}
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    label={t("Lohnart")}
                    select
                    value={logikLoa}
                    onChange={(e) => {
                      setLogikLoa(e.target.value);
                      console.log(e.target.value);
                    }}
                  >
                    {logikloas.map((item, index) => {
                      return (
                        <MenuItem key={index} value={index} index={index}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    label={t("Übernahmeart")}
                    value={logikArt}
                    select
                    onChange={(e) => setLogikArt(e.target.value)}
                  >
                    {logikarten.map((item, index) => {
                      return (
                        <MenuItem key={index} value={index} index={index}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    type="number"
                    size="small"
                    variant="outlined"
                    label={t("Wert")}
                    value={logikWert}
                    onChange={(e) => setLogikWert(e.target.value)}
                  />
                </Grid>
              </Fragment>
            )}
            {feldlogik[eingabeLogik] && feldlogik[eingabeLogik].key === "04" && <Fragment>{/*  Logik für Saldenauszahlung  */}</Fragment>}
          </Grid>
        </Box>
      </ResponsiveDialog>
    );
  }
  function NeuesDatenbankfeld() {
    return (
      <ResponsiveDialog
        title={t("Datenbankfeld")}
        open={openDfeld !== ""}
        setOpen={() => setOpenDfeld("")}
        actionButton={
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item>
              <Button variant="outlined" color="primary" onClick={() => Reset()}>
                {t("Abbrechen")}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  openGruppe !== "" ? SpeichernDfeld(listeGruppe, "listeGruppe") : SpeichernDfeld(listeFormular, "listeFormular");
                }}
              >
                {t("Speichern")}
              </Button>
            </Grid>
            {openDfeld === "loaded" && (
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    confirm({
                      text: "Sind Sie sicher, dass Sie das Datenbankfeld löschen möchten ?",
                      title: "Löschen",
                      buttons: "YESNO",
                    })
                      .then(() => {
                        if (openGruppe !== "") {
                          LoeschenFeld(listeGruppe, "listeGruppe");
                        } else {
                          LoeschenFeld(listeFormular, "listeFormular");
                        }
                      })
                      .catch((antwort) => {});
                  }}
                >
                  {t("Löschen")}
                </Button>
              </Grid>
            )}
          </Grid>
        }
      >
        <Box p={2}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12}>
              <TextField size="small" fullWidth variant="outlined" label={t("Kennung")} value={feldKey} disabled />
            </Grid>
            <Grid item xs={12}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label={t("Bezeichnung")}
                value={feldBez}
                onChange={(e) => setFeldBez(e.target.value)}
                autoFocus
              />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth size="small" variant="outlined" label={t("Datenbank")} value={dfeldDb} select onChange={(e) => setDfeldDb(e.target.value)}>
                {dbliste.map((item, index) => {
                  return (
                    <MenuItem key={index} value={index} index={index}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label={t("Datenbankfeld")}
                value={dfeldFeld}
                select
                onChange={(e) => setDfeldFeld(e.target.value)}
              >
                {dbliste[dfeldDb]?.felder.map((item, index) => {
                  return (
                    <MenuItem key={index} value={index} index={index}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label={t("Textformat")}
                value={feldFormat}
                select
                onChange={(e) => setFeldFormat(e.target.value)}
              >
                {format.map((item, index) => {
                  return (
                    <MenuItem key={index} value={index} index={index}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                type="text"
                size="small"
                variant="outlined"
                label={t("Übergabekey")}
                value={feldUeb}
                onChange={(e) => prfFeldUeb(e.target.value)}
              />
            </Grid>
          </Grid>
        </Box>
      </ResponsiveDialog>
    );
  }
  function NeuesPFeld() {
    return (
      <ResponsiveDialog
        title={t("Programmfeld")}
        open={openPFeld !== ""}
        setOpen={() => setOpenPfeld("")}
        actionButton={
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item>
              <Button variant="outlined" color="primary" onClick={() => Reset()}>
                {t("Abbrechen")}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  openGruppe !== "" ? SpeichernPFeld(listeGruppe, "listeGruppe") : SpeichernPFeld(listeFormular, "listeFormular");
                }}
              >
                {t("Speichern")}
              </Button>
            </Grid>
            {openPFeld === "loaded" && (
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    confirm({
                      text: "Sind Sie sicher, dass Sie das Programmfeld löschen möchten ?",
                      title: "Löschen",
                      buttons: "YESNO",
                    })
                      .then(() => {
                        if (openGruppe !== "") {
                          LoeschenFeld(listeGruppe, "listeGruppe");
                        } else {
                          LoeschenFeld(listeFormular, "listeFormular");
                        }
                      })
                      .catch((antwort) => {});
                  }}
                >
                  {t("Löschen")}
                </Button>
              </Grid>
            )}
          </Grid>
        }
      >
        <Box p={2}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12}>
              <TextField size="small" fullWidth variant="outlined" label={t("Kennung")} value={feldKey} disabled />
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label={t("Bezeichnung")}
                value={feldBez}
                onChange={(e) => setFeldBez(e.target.value)}
                autoFocus
              />
              <TextField
                id="programm"
                label={t("Programm")}
                select
                fullWidth
                value={pfeldExtra}
                style={{ marginTop: "12px" }}
                variant="outlined"
                onChange={(e) => setPfeldExtra(e.target.value)}
                // onChange={(e) => setPfeldInhalt(e.target.value)}
              >
                {pfeldtyp.map((pfeld) => (
                  <MenuItem value={pfeld.key}>{pfeld.name}</MenuItem>
                ))}
              </TextField>

              {pfeldtyp
                .find((e) => e.key === pfeldExtra)
                ?.settings?.map((setting) => {
                  if (setting?.type === "multiLine") {
                    return (
                      <TextField
                        onChange={(e) => changePfeldInhalt(e.target.value, setting.key)}
                        value={pfeldInhalt?.[setting.key]}
                        style={{ marginTop: "12px" }}
                        label={setting?.label}
                        multiline
                        fullWidth
                      />
                    );
                  }
                  if (setting?.type === "checkbox") {
                    return (
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={pfeldInhalt?.[setting.key]} onChange={(e) => changePfeldInhalt(e.target.checked, setting.key)} />}
                          label={setting?.label}
                        />
                      </FormGroup>
                    );
                  }

                  if (setting?.type === "VMATabelleEinstellen") {
                    return (
                      <>
                        {" "}
                        <Button fullWidth onClick={() => setVmaTabelleDialog(true)}>
                          Individuelle VMA Tabelle hinterlegen{" "}
                        </Button>
                        <VMATabelleEinstellen
                          open={vmaTabelleDialog}
                          onOpenChange={setVmaTabelleDialog}
                          onSave={(tabelle) => changePfeldInhalt(tabelle, setting.key)}
                          value={pfeldInhalt?.[setting.key]}
                          standardTabelle={vmaStandardTabelle}
                        />
                      </>
                    );
                  }
                })}
            </Grid>
          </Grid>
        </Box>
      </ResponsiveDialog>
    );
  }

  function NeuesStammfeld() {
    return (
      <ResponsiveDialog
        title={t("Stammfeld")}
        open={openSfeld !== ""}
        setOpen={() => setOpenSfeld("")}
        actionButton={
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item>
              <Button variant="outlined" color="primary" onClick={() => Reset()}>
                {t("Abbrechen")}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  SpeichernSfeld(listeFormular, "listeFormular");
                }}
              >
                {t("Speichern")}
              </Button>
            </Grid>
          </Grid>
        }
      >
        <Box p={2}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12}>
              <TextField fullWidth size="small" variant="outlined" label={t("Kennung")} value={feldKey} disabled />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label={t("Bezeichnung")}
                value={feldBez}
                disabled
                onChange={(e) => setFeldBez(e.target.value)}
                autoFocus
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                type="text"
                size="small"
                variant="outlined"
                label={t("Übergabekey")}
                value={feldUeb}
                onChange={(e) => prfFeldUeb(e.target.value)}
              />
            </Grid>
          </Grid>
        </Box>
      </ResponsiveDialog>
    );
  }
  function displayMandantenList() {
    //Die Liste der zugelassenen Mandanten anzeigen
    const tmpPgm = zulassung.programs.find((pgm) => {
      return pgm.prg === "FORGEN";
    });
    const displayClients = tmpPgm?.mandanten?.map((dataObject) => {
      // if (dataObject.key === client) { return }
      const name = dataObject.name;
      return (
        <Fragment key={dataObject.key}>
          <Divider component="li" light />
          <ListItemButton key={dataObject.key} onClick={() => handleMandantenClick(dataObject)}>
            <ListItemIcon>
              <Checkbox checked={listMandant.indexOf(dataObject) !== -1} tabIndex={-1} disableRipple inputProps={{ "aria-label": "primary checkbox" }} />
            </ListItemIcon>
            <ListItemText primary={name} secondary={dataObject.vkey} />
          </ListItemButton>
        </Fragment>
      );
    });
    return displayClients;
  }
  //Rückgabe
  return (
    <Fragment>
      {renderLaden()}
      {renderSpeichern()}
      {NeueEingabe()}
      {NeueInfo()}
      {NeueGruppe()}
      {NeueDatumsGruppe()}
      {NeuesRechenfeld()}
      {NeuesDatenbankfeld()}
      {NeuesPFeld()}
      {NeuesStammfeld()}
      <Grid container justifyContent="center" spacing={2}>
        <Grid item xs={12}>
          {renderHeader()}
        </Grid>
      </Grid>
      <Grid container justifyContent="flex-start" spacing={2}>
        <Grid item xs={12} md={2}>
          <Box p={3}>
            <Card>
              <Box p={2}>
                <Grid container justifyContent="center" spacing={2}>
                  <Typography>{t("Formularfunktionen")}</Typography>
                  <hr align="center" width="100%" height="2px" />
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        NeuFormular();
                      }}
                    >
                      {t("Neues Formular")}
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        formulare && formulare.length > 0 ? setOpenLaden(1) : showErrorMessage(t("Es liegen noch keine gespeicherten Formulare vor"));
                      }}
                    >
                      {t("Formular Laden")}
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        setOpenSpeichern(1);
                      }}
                    >
                      {t("Formular Speichern")}
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        confirm({
                          text: "Sind Sie sicher, dass Sie das gesamte Formular löschen möchten ?",
                          title: "Löschen",
                          buttons: "YESNO",
                        })
                          .then(() => {
                            LoeschenFormular();
                          })
                          .catch((antwort) => {});
                      }}
                    >
                      {t("Formular Löschen")}
                    </Button>
                  </Grid>
                  <Typography>{t("Neue Felder")}</Typography>
                  <hr align="center" width="100%" height="2px" />
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        setFeldKey("E" + pad(maxEingabe[formular], 3).toString());
                        setOpenFeld("empty");
                      }}
                    >
                      {t("Neue Eingabe")}
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        setFeldKey("I" + pad(maxInfo[formular], 3).toString());
                        setOpenInfo("empty");
                        setFeldBez("Infotext");
                      }}
                    >
                      {t("Neue Info")}
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        setGruppeKey("G" + pad(maxGruppe[formular], 3).toString());
                        setOpenGruppe("empty");
                      }}
                    >
                      {t("Neue Gruppe")}
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        setGruppeKey("V" + pad(maxDatumsGruppe[formular], 3).toString());
                        setOpenDatumsGruppe("empty");
                      }}
                    >
                      {t("Neue Datumsgruppe")}
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        setFeldKey("R" + pad(maxRfeld[formular], 3).toString());
                        setOpenRfeld("empty");
                      }}
                    >
                      {t("Neues Rechenfeld")}
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        setFeldKey("D" + pad(maxDfeld[formular], 3).toString());
                        setOpenDfeld("empty");
                      }}
                    >
                      {t("Neues Datenbankfeld")}
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        setFeldKey("P" + pad(maxPfeld[formular], 3).toString());
                        setOpenPfeld("empty");
                      }}
                    >
                      {t("Neues Programm Feld")}
                    </Button>
                  </Grid>
                  <Typography>{t("Vorschau")}</Typography>
                  <hr align="center" width="100%" height="2px" />
                  <Grid item xs={12}>
                    <Button fullWidth variant="outlined" color="primary" onClick={() => setOpenVorschau(1)}>
                      {t("Vorschau")}
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button fullWidth variant="outlined" color="primary" onClick={() => setOpenVorschau(0)}>
                      {t("Generator")}
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button fullWidth variant="outlined" color="primary" onClick={() => Plausibilitaetspruefung()} disabled={openVorschau === 0}>
                      {t("Formular prüfen")}
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button fullWidth variant="outlined" color="primary" onClick={() => LoadPdf()}>
                      {t("PDF Vorschau")}
                    </Button>
                  </Grid>
                  <Typography>{t("Lokaler Speicher")}</Typography>
                  <hr align="center" width="100%" height="2px" />
                  <Grid item xs={12}>
                    <Button fullWidth variant="outlined" color="primary" onClick={() => LoadLocal()}>
                      {t("Lokalen Speicher laden")}
                    </Button>
                  </Grid>
                  {(clientServer === "ecintern" || clientServer === "admin") && (
                    <>
                      <Typography>{t("Datenbankfunktionen")}</Typography>
                      <hr align="center" width="100%" height="2px" />
                      <Grid item xs={12}>
                        <Button fullWidth variant="outlined" disabled={formular === "F000"} color="primary" onClick={() => setOpenMandantSelect(true)}>
                          {formular === "F000" ? t("Bitte Formular auswählen") : t("Datenbank kopieren")}
                        </Button>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Box>
            </Card>
          </Box>
        </Grid>

        {openMandantSelect && (
          <>
            <ResponsiveDialog
              title={t(`Zu welchen Mandanten soll die jetzige Datenbank (${client}) kopiert werden`)}
              open={openMandantSelect}
              setOpen={setOpenMandantSelect}
            >
              <div className="w-full flex">
                <List>{displayMandantenList()}</List>
                <div className="flex">
                  <Button
                    sx={{ width: 1 / 3 }}
                    variant="outlined"
                    color="error"
                    onClick={() => {
                      setOpenMandantSelect(false);
                      setListMandant([]);
                    }}
                  >
                    {t("Abbrechen")}
                  </Button>

                  <Button
                    sx={{ width: 1 / 3, float: "right" }}
                    variant="outlined"
                    color="primary"
                    disabled={listMandant.length === 0}
                    onClick={() => copyDatabase()}
                  >
                    {t("Auswahl Abgeschlossen")}
                  </Button>
                </div>
              </div>
            </ResponsiveDialog>
          </>
        )}
        {openMandanFormularSelect && (
          <>
            <ResponsiveDialog title={t("Test")} open={openMandanFormularSelect} setOpen={setOpenMandantFormularSelect}>
              <Box p={2}>
                <Grid container justifyContent="center" spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label={t("Mandant")}
                      value={listMandant}
                      select
                      onChange={(e) => {
                        setListMandant(e.target.value);
                        setListFormular([]);
                      }}
                    >
                      {mandantenFormulare?.map((item, index) => {
                        return (
                          <MenuItem key={item.key} value={item.key} index={item.key}>
                            {item.bez + " " + item.vkey}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label={t("Formular")}
                      value={listFormular}
                      select
                      onChange={(e) => {
                        setListFormular(e.target.value);
                      }}
                    >
                      {mandantenFormulare
                        ?.find((e) => e.key === listMandant)
                        ?.formulare?.map((item, index) => {
                          return (
                            <MenuItem key={item.key} value={item.key} index={item.key}>
                              {item.bez}
                            </MenuItem>
                          );
                        })}
                    </TextField>
                  </Grid>
                </Grid>
              </Box>

              <div className="flex">
                <Button
                  sx={{ width: 1 / 3 }}
                  variant="outlined"
                  color="error"
                  onClick={() => {
                    setOpenMandantFormularSelect(false);
                    setListMandant([]);
                  }}
                >
                  {t("Abbrechen")}
                </Button>

                <Button
                  sx={{ width: 1 / 3, float: "right" }}
                  variant="outlined"
                  color="primary"
                  // disabled={listMandant.length === 0}
                  onClick={() => copyGruppeAufAnderesMandat()}
                >
                  {t("Auswahl Abgeschlossen")}
                </Button>
              </div>
            </ResponsiveDialog>
          </>
        )}

        {openVorschau === 1 && (
          <Grid item xs={12} md={10}>
            <Formular
              key={felder[formular]}
              bez={formularBez}
              formular={formular}
              liste={listeFormular}
              felder={felder}
              stammfelder={stammfelder}
              hper={hper}
              ChangeFelder={ChangeFelder}
              felderError={felderError}
              uebergaben={uebergaben}
              ChangeFiles={ChangeFiles}
              files={files}
              DateiLaden={DateiLaden}
              dbliste={dbliste}
              client={client}
              accessToken={accessToken}
              program={"FORGEN"}
            />
          </Grid>
        )}
        {openVorschau !== 1 && (
          <Grid item xs={12} md={10}>
            <FormularAufbau
              formular={formular}
              felder={felder}
              stammfelder={stammfelder}
              listeFormular={listeFormular}
              lStamm={listeStamm.filter((item) => {
                return listeFormular.some((item2) => item2 === item) === false;
              })}
              ChangeFormular={(l) => SaveLocal("listeFormular", l)}
              FeldBearbeiten={FeldBearbeiten}
              NewSfeld={NewSfeld}
              CopyFeld={CopyFeld}
              DelFeld={DelFeld}
            />
          </Grid>
        )}
      </Grid>
      {loading && <FullPageSpinner />}
    </Fragment>
  );
}
export default FormularGenerator;
